"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeStylableDirectiveRules = exports.addStylableDirectiveRules = exports.fontThemesImport = exports.jsModulesImport = void 0;
var injections_1 = require("./injections");
var consts_1 = require("../consts");
var defaultIncludeDirectives = {
    breakpoints: true,
    siteColors: true,
    fontClasses: true,
    additionalJsModules: false
};
var wrapCssDirectives = function (css) {
    return "/* START STYLABLE DIRECTIVE RULES */\n" + css + "\n/* END STYLABLE DIRECTIVE RULES */\n";
};
var removeCssDirectives = function (css) { return css.replace(/\/\* START STYLABLE DIRECTIVE RULES \*\/\n[\s\S]*\n\/\* END STYLABLE DIRECTIVE RULES \*\/\n/, ''); };
var siteVars = ":import {-st-from: '" + consts_1.SITE_ST_CSS_PATH + "'; -st-named: site_1_1, site_2_1, site_3_1, site_4_1, site_5_1, site_1_2, site_2_2, site_3_2, site_4_2, site_5_2, site_1_3, site_2_3, site_3_3, site_4_3, site_5_3, site_1_4, site_2_4, site_3_4, site_4_4, site_5_4, site_1_5, site_2_5, site_3_5, site_4_5, site_5_5;}\n";
var fontThemeClasses = ":import {-st-from: '" + consts_1.SITE_ST_CSS_PATH + "'; -st-named: font_0, font_1, font_2, font_3, font_4, font_5, font_6, font_7, font_8, font_9, font_10;}\n";
exports.jsModulesImport = ":import {-st-from: '" + consts_1.wixMediaUrlName + "';-st-default: " + consts_1.wixMediaUrlFormatter + ";}";
exports.fontThemesImport = ":import {-st-from: '" + consts_1.wixFontThemesName + "';-st-named: font_0, font_1, font_2, font_3, font_4, font_5, font_6, font_7, font_8, font_9, font_10;}";
exports.addStylableDirectiveRules = function (stCss, isMobile, include) {
    if (include === void 0) { include = defaultIncludeDirectives; }
    return wrapCssDirectives((include.breakpoints ? (injections_1.generateStylableBreakpoints(isMobile) + '\n') : '') +
        (include.siteColors ? siteVars : '') + (include.additionalJsModules ? exports.jsModulesImport : '') +
        (include.fontClasses ? fontThemeClasses : '')) + stCss;
};
exports.removeStylableDirectiveRules = function (stCss) {
    return removeCssDirectives(stCss) // TODO: Deprecate the replace logic
        .replace(new RegExp(siteVars, 'g'), '')
        .replace(new RegExp(exports.jsModulesImport, 'g'), '')
        .replace(new RegExp(":vars {\\s+" + consts_1.mobileMediaQueryVarName + ":\\s.*;\\s}\\n", 'gm'), '');
};
//# sourceMappingURL=directives.js.map